import { render, staticRenderFns } from "./CharacterFaceEditor.vue?vue&type=template&id=75b5a759&lang=pug&"
import script from "./CharacterFaceEditor.vue?vue&type=script&lang=js&"
export * from "./CharacterFaceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterFaceEditor.vue"
export default component.exports